import { TFunction } from 'i18next'
import * as yup from 'yup'
import { StringSchema } from 'yup'

import { formTranslation } from '@/Shared/ui/sharedTranslation'

const validateDNI = (dni: string): boolean => {
  const validChars = 'TRWAGMYFPDXBNJZSQVHLCKET'
  const nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i
  const nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i
  const document = dni?.toString().toUpperCase()

  if (!nifRexp.test(document) && !nieRexp.test(document)) return false

  const nie = document.replace(/^[X]/, '0').replace(/^[Y]/, '1').replace(/^[Z]/, '2')

  const letter = document.substr(-1)
  const charIndex = parseInt(nie.substr(0, 8)) % 23

  if (validChars.charAt(charIndex) === letter) return true

  return false
}

const validateCIF = (cif: string): boolean => {
  const cifRegex = /^[A-HJ-NP-SUVW][0-9]{7}[0-9A-J]$/
  if (!cifRegex.test(cif)) {
    return false
  }

  const control = 'JABCDEFGHI'
  const digits = cif.substr(1, cif.length - 2)
  const lastChar = cif.charAt(cif.length - 1)

  let evenSum = 0
  let oddSum = 0
  for (let i = 0; i < digits.length; i++) {
    const n = parseInt(digits[i], 10)

    if (i % 2 === 0) {
      const v = 2 * n
      oddSum += v > 9 ? Math.floor(v / 10) + (v % 10) : v
    } else {
      evenSum += n
    }
  }

  const sum = evenSum + oddSum
  const lastDigit = (10 - (sum % 10)) % 10
  const isNumeric = !isNaN(parseInt(lastChar, 10))

  return isNumeric
    ? lastDigit === parseInt(lastChar, 10)
    : lastChar === control[lastDigit]
}

export const dniOrCifSchema = (t: TFunction<'translation', undefined>): StringSchema => {
  return yup
    .string()
    .required(t(formTranslation.errors.fieldRequired))
    .test('is-dni-or-cif', t(formTranslation.errors.invalidCifOrDni), value => {
      if (typeof value === 'string') {
        return validateDNI(value) || validateCIF(value)
      }
      return false
    })
}
